import { render, staticRenderFns } from "./modal-search.vue?vue&type=template&id=6c4adbd8&"
import script from "./modal-search.vue?vue&type=script&lang=js&"
export * from "./modal-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports